export function getCurrentQuarterAndYear(){
    let currentYear = new Date();
    let currentQuarter = Math.floor(new Date().getMonth() / 3);

    if (currentQuarter === 0) {
        currentYear.setFullYear(currentYear.getFullYear() - 1);
        currentQuarter = 4;
    }

    return {
        currentYear,
        currentQuarter
    };
}
